import { render, staticRenderFns } from "./EventLinkedPage.vue?vue&type=template&id=0fd1d669&scoped=true&"
import script from "./EventLinkedPage.vue?vue&type=script&lang=js&"
export * from "./EventLinkedPage.vue?vue&type=script&lang=js&"
import style0 from "./EventLinkedPage.vue?vue&type=style&index=0&id=0fd1d669&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fd1d669",
  null
  
)

export default component.exports